import { DateTime } from 'luxon';

const getDate = (date: string) => DateTime.fromISO(date)?.toLocaleString(DateTime.DATETIME_SHORT);

export const getSeconds = (date: number) => DateTime.fromMillis(date)?.toFormat('HH:mm:ss');

export const getChartTime = (date: number | string, hours: number) => {
  const convertedDate = typeof date === 'string' ? new Date(date).valueOf() : date;
  if (hours > 24) {
    return DateTime.fromMillis(convertedDate)?.toFormat('ccc HH:mm');
  }
  return DateTime.fromMillis(convertedDate)?.toFormat('HH:mm')
};

export const getTooltipLabel = (date: number | string) => {
  const convertedDate = typeof date === 'string' ? new Date(date).valueOf() : date;
  return DateTime.fromMillis(convertedDate)?.toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS);
}

export default getDate;
